/**
 * Text Utilities
 *
 * Pure utility functions for text manipulation.
 */

export function safeDecodeURIComponent(value: string): string {
	try {
		return decodeURIComponent(value)
	} catch {
		return value
	}
}
